module.exports = __webpack_public_path__ + "static/media/goodJob.e4e10047.svg";